(function() {
  'use strict';
  /* Idempotency guard — this script is included from BOTH main-product--default.liquid
     and size-guide-modal.liquid because both sections need its behaviour. On
     /collections/<handle>/products/<handle> URLs Shopify renders both sections,
     causing the script to load twice. Without this guard the second load binds
     a second click handler on the dropdown button, which toggles the menu state
     a second time — net effect: tap appears to do nothing. */
  if (window.__caseSwitcherLoaded) return;
  window.__caseSwitcherLoaded = true;
  /* deploy: 2026-05-27 decouple modal init from case-switcher */

  /* ============================================================================
     Collection Case Switcher (v2) — single dropdown + Size Guide modal.
     Every sibling product in the collection appears as a discrete entry.
     No Standard/Expandable toggle — type is just part of each product's title.
     ============================================================================ */

  /* ── Reposition the switcher into the desktop product meta ── */
  function repositionSwitcher() {
    var el = document.querySelector('[data-case-switcher]');
    if (!el) return false;
    var desktopMeta = document.querySelector('.product__details .product__meta');
    if (!desktopMeta) return false;
    var monogramBlock = desktopMeta.querySelector('.product__controls-group--text');
    if (monogramBlock) {
      desktopMeta.insertBefore(el, monogramBlock);
    } else {
      var formBlock = desktopMeta.querySelector('.product-form');
      if (formBlock) {
        desktopMeta.insertBefore(el, formBlock);
      } else {
        var headerBlock = desktopMeta.querySelector('.product__block--product-header');
        if (!headerBlock) return false;
        var nextSib = headerBlock.nextElementSibling;
        if (nextSib) {
          desktopMeta.insertBefore(el, nextSib);
        } else {
          desktopMeta.appendChild(el);
        }
      }
    }
    el.style.visibility = 'visible';
    el.style.position   = 'relative';
    el.style.height     = 'auto';
    el.style.overflow   = 'visible';
    return true;
  }

  function attemptReposition(tries) {
    if (tries <= 0) return;
    if (!repositionSwitcher()) {
      setTimeout(function() { attemptReposition(tries - 1); }, 100);
    } else {
      initSwitcher();
    }
  }

  /* ── Sort key: by size order, then standard before expandable ── */
  var SIZE_ORDER = ['carry-on', 'front-pocket-carry-on', 'large-carry-on', 'check-in', 'large-check-in'];

  function sizeSlug(title) {
    var t = title.toLowerCase();
    if (/large carry[\-\s]?on/.test(t))               return 'large-carry-on';
    if (/large check[\-\s]?in/.test(t))               return 'large-check-in';
    if (/front[\s]?pocket[\s]?carry[\-\s]?on/.test(t)) return 'front-pocket-carry-on';
    if (/carry[\-\s]?on/.test(t))                     return 'carry-on';
    if (/check[\-\s]?in/.test(t))                     return 'check-in';
    return 'zzz';
  }

  function isExpandable(title) {
    return title.toLowerCase().indexOf('expandable') !== -1 ? 1 : 0;
  }

  function productSortKey(product) {
    var slugIdx = SIZE_ORDER.indexOf(sizeSlug(product.title));
    if (slugIdx === -1) slugIdx = SIZE_ORDER.length;
    /* Standard (0) before Expandable (1) within the same size */
    return slugIdx * 10 + isExpandable(product.title);
  }

  /* ── Case dimensions lookup (keyed by sizeSlug + type) ──
     Source-of-truth: /pages/roam-luggage-case-size-guide. If those dimensions
     change, update this table to keep dropdown labels in sync. */
  var DIMENSIONS_TABLE = {
    'carry-on':              { standard: '22h x 14.25w x 9d',    expandable: '22h x 14.25w x 11d' },
    'front-pocket-carry-on': { standard: '22h x 14.25w x 9.75d', expandable: '22h x 14.25w x 11.75d' },
    'large-carry-on':        { standard: '22h x 16.25w x 9d',    expandable: '22h x 16.25w x 11d' },
    'check-in':              { standard: '26h x 17.5w x 10.5d',  expandable: '26h x 17.5w x 12.5d' },
    'large-check-in':        { standard: '30h x 19.5w x 11d',    expandable: '30h x 19.5w x 13d' }
  };

  function getDimensions(title) {
    var entry = DIMENSIONS_TABLE[sizeSlug(title)];
    if (!entry) return '';
    return isExpandable(title) ? (entry.expandable || '') : (entry.standard || '');
  }

  /* ── Main switcher init ── */
  function initSwitcher() {
    var el = document.querySelector('[data-case-switcher]');
    if (!el) return;

    var currentHandle = el.getAttribute('data-current-product-handle');
    var collHandle    = el.getAttribute('data-collection-handle');
    var familyTag     = el.getAttribute('data-family-tag') || '';
    var sizeBtn       = el.querySelector('[data-switcher-size-btn]');
    var sizeMenu      = el.querySelector('[data-switcher-size-menu]');
    var arrow         = el.querySelector('[data-switcher-arrow]');

    /* ── Dropdown open/close ── */
    if (sizeBtn && sizeMenu) {
      sizeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = sizeMenu.classList.contains('case-switcher__size-menu--open');
        if (isOpen) {
          closeDropdown();
        } else {
          sizeMenu.classList.add('case-switcher__size-menu--open');
          sizeBtn.setAttribute('aria-expanded', 'true');
          if (arrow) arrow.classList.add('case-switcher__arrow--open');
        }
      });

      /* Close on outside click */
      document.addEventListener('click', function(e) {
        if (!el.contains(e.target)) closeDropdown();
      });
      /* Close on Escape */
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeDropdown();
      });
    }

    function closeDropdown() {
      if (!sizeMenu) return;
      sizeMenu.classList.remove('case-switcher__size-menu--open');
      if (sizeBtn) sizeBtn.setAttribute('aria-expanded', 'false');
      if (arrow) arrow.classList.remove('case-switcher__arrow--open');
    }

    /* ── Fetch and populate ── */
    if (!collHandle) return;

    /* F-A1 (2026-06-18): If the Liquid snippet (snippets/collection-case-switcher.liquid)
       already server-rendered the full family of siblings, the menu has >1
       items. Skip the fetch+wipe+rebuild path entirely — the server-rendered
       version is the source of truth and is identical in sort order and dims
       to what we'd produce here. This also eliminates the network round-trip
       on every Americana / DG / Sets PDP. */
    if (sizeMenu && sizeMenu.querySelectorAll('.case-switcher__size-item').length > 1) {
      return;
    }

    fetchAllProducts(collHandle, function(products) {
      /* Filter to siblings:
         - drop B4U / customizer products
         - drop "set" bundles unless current product is itself a Sets family member
         - filter to the same product-line family as the current product
           (Americana / Sets / DG). This is the key fix that prevents cross-line
           contamination (e.g., Americana products showing on a Designer
           Collection PDP, even when both live in the same /collections/all-luggage). */
      var siblings = products.filter(function(p) {
        var t = (p.title || '').toLowerCase();
        var h = (p.handle || '').toLowerCase();
        if (t.indexOf('b4u') !== -1 || h.indexOf('b4u') !== -1) return false;

        /* Family-tag match. If we don't know the current product's family,
           fall back to "no Americana, no Sets" (legacy behavior) to avoid
           showing irrelevant products. */
        var tags = p.tags || [];
        if (familyTag) {
          if (tags.indexOf(familyTag) === -1) return false;
        } else {
          if (tags.indexOf('Americana') !== -1) return false;
          if (tags.indexOf('Sets') !== -1) return false;
        }
        return true;
      });

      /* Sort by size order, standard before expandable */
      siblings.sort(function(a, b) {
        return productSortKey(a) - productSortKey(b);
      });

      /* Populate dropdown — every product is its own row */
      if (!sizeMenu) return;
      /* F-A1 (2026-06-18): If the fetch returned no siblings (network error,
         CDN miss, or genuinely empty collection), don't wipe whatever the
         server already rendered. Better to keep the Liquid fallback / current-
         product placeholder than to blank the menu entirely. */
      if (siblings.length === 0) return;
      sizeMenu.innerHTML = '';
      siblings.forEach(function(p) {
        var isCurrent = p.handle === currentHandle;
        var label = p.title;
        var dims = getDimensions(p.title);
        var nameEl = document.createElement('span');
        nameEl.className = 'case-switcher__size-item-name';
        nameEl.textContent = label;
        var dimsEl = null;
        if (dims) {
          dimsEl = document.createElement('span');
          dimsEl.className = 'case-switcher__size-item-dims';
          dimsEl.textContent = dims;
        }
        if (isCurrent) {
          var div = document.createElement('div');
          div.className = 'case-switcher__size-item case-switcher__size-item--active';
          div.setAttribute('role', 'option');
          div.setAttribute('aria-selected', 'true');
          div.setAttribute('data-switcher-size', p.handle);
          div.appendChild(nameEl);
          if (dimsEl) div.appendChild(dimsEl);
          sizeMenu.appendChild(div);
        } else {
          var a = document.createElement('a');
          a.className = 'case-switcher__size-item';
          a.setAttribute('role', 'option');
          a.setAttribute('data-switcher-size', p.handle);
          a.href = collectionProductUrl(collHandle, p.handle);
          a.appendChild(nameEl);
          if (dimsEl) a.appendChild(dimsEl);
          sizeMenu.appendChild(a);
        }
      });
    });
  }

  /* ── Build collection product URL (preserve preview_theme_id) ── */
  function collectionProductUrl(collHandle, productHandle) {
    var url = '/collections/' + collHandle + '/products/' + productHandle;
    var params = new URLSearchParams(window.location.search);
    var previewId = params.get('preview_theme_id');
    if (previewId) url += '?preview_theme_id=' + previewId;
    return url;
  }

  /* ── Paginated fetch of all collection products ── */
  function fetchAllProducts(collHandle, callback) {
    var all = [];
    function fetchPage(page) {
      var url = '/collections/' + collHandle + '/products.json?limit=250&page=' + page;
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.products && data.products.length > 0) {
            all = all.concat(data.products);
            if (data.products.length === 250) {
              fetchPage(page + 1);
            } else {
              callback(all);
            }
          } else {
            callback(all);
          }
        })
        .catch(function() { callback(all); });
    }
    fetchPage(1);
  }

  /* ============================================================================
     Size Guide modal — structured card carousel
     ============================================================================
     Cards are built from a JSON payload emitted by the Liquid snippet (search
     for `data-size-guide-data` in collection-case-switcher.liquid). Each card
     shows: illustration, case name + type badge, dimensions, weight, capacity,
     and a "journey" description.

     Carousel pattern: CSS scroll-snap + arrow buttons (desktop) + pagination
     dots (mobile). No 3rd-party JS library.
     ============================================================================ */
  function initSizeGuideModal() {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;

    /* Portal the modal to <body> so it escapes any parent stacking context.
       Without this, the modal renders inside .product__meta (z-index:1 stacking
       context) and the product gallery's arrows (z-index:10 in a sibling
       stacking context) draw on top of it. Moving to <body> makes the modal
       a top-level element where its z-index:9999 wins absolutely. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    var openers   = document.querySelectorAll('[data-size-guide-open]');
    var closers   = modal.querySelectorAll('[data-size-guide-modal-close]');
    var track     = modal.querySelector('[data-size-guide-track]');
    var prevBtn   = modal.querySelector('[data-size-guide-prev]');
    var nextBtn   = modal.querySelector('[data-size-guide-next]');
    var dotsEl    = modal.querySelector('[data-size-guide-dots]');
    var dataEl    = modal.querySelector('[data-size-guide-data]');
    var rendered  = false;

    openers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
    });
    closers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        closeModal();
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });

    function openModal() {
      modal.removeAttribute('hidden');
      document.documentElement.classList.add('case-switcher-size-guide--open');
      if (!rendered) renderSizeGuide();
    }
    function closeModal() {
      modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('case-switcher-size-guide--open');
    }

    function renderSizeGuide() {
      if (!track || !dataEl) return;
      var cases = [];
      try {
        cases = JSON.parse(dataEl.textContent || '[]');
      } catch (err) {
        cases = [];
      }
      if (!cases.length) {
        track.innerHTML = '<li class="case-switcher-size-guide-modal__empty">Sorry — the Size Guide could not be loaded.</li>';
        return;
      }

      track.innerHTML = cases.map(function(c, i) {
        var fallback = '—';
        var weight   = c.weight   || fallback;
        var capacity = c.capacity || fallback;
        var journey  = c.journey  || fallback;

        /* Dimensions — single value per card, no label. For expandable cards
           we show ONLY the unexpanded (compressed) dimension, since that's
           what matters for shipping/carry-on size compliance. The expanded
           dimension is implied by the "Expandable" word in the title. */
        var dimsValue = c.dimensionsUnexpanded || c.dimensions;
        var dimsRows = '<div class="sg-card__row"><dd>' + escapeText(dimsValue) + '</dd></div>';

        /* Expansion-% pill removed per design. Section setting
           card_N_expansion_percent is now unused by render; left in the
           schema for now in case it's wanted back later. */

        /* Compose display name. Expandable cards get " Expandable" suffixed
           into the title; the separate type subhead row has been removed
           per design. Preserves merchant-edited section settings — the
           card_N_name + card_N_type_label fields still drive output. */
        var displayName = c.name + (c.typeLabel && /expandable/i.test(c.typeLabel) ? ' Expandable' : '');

        return ''
          + '<li class="sg-card" data-sg-index="' + i + '">'
          +   '<div class="sg-card__illo">'
          +     '<img src="' + c.illustration + '" alt="' + escapeAttr(displayName) + '" loading="lazy" decoding="async" />'
          +   '</div>'
          +   '<div class="sg-card__name">' + escapeText(displayName) + '</div>'
          +   '<dl class="sg-card__specs">'
          +     dimsRows
          +     '<div class="sg-card__row"><dd>' + escapeText(weight)   + '</dd></div>'
          +     '<div class="sg-card__row"><dd>' + escapeText(capacity) + '</dd></div>'
          +     '<div class="sg-card__row"><dd>' + escapeText(journey)  + '</dd></div>'
          +   '</dl>'
          + '</li>';
      }).join('');

      /* ── Pagination dots (mobile) ── */
      if (dotsEl) {
        dotsEl.innerHTML = cases.map(function(_, i) {
          return '<button type="button" class="sg-dot' + (i === 0 ? ' sg-dot--active' : '') + '" data-sg-dot="' + i + '" aria-label="Go to case ' + (i + 1) + '"></button>';
        }).join('');
        dotsEl.querySelectorAll('[data-sg-dot]').forEach(function(d) {
          d.addEventListener('click', function() {
            var idx = parseInt(d.getAttribute('data-sg-dot'), 10) || 0;
            scrollToCard(idx);
          });
        });
      }

      /* ── Arrow handlers ── */
      function cardStep() {
        var first = track.querySelector('.sg-card');
        if (!first) return 0;
        var rect = first.getBoundingClientRect();
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return rect.width + gap;
      }
      function scrollToCard(idx) {
        var step = cardStep();
        track.scrollTo({ left: step * idx, behavior: 'smooth' });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left:  cardStep(), behavior: 'smooth' });
        });
      }

      /* ── IntersectionObserver: highlight the most-visible card's dot ── */
      if ('IntersectionObserver' in window && dotsEl) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              var idx = parseInt(entry.target.getAttribute('data-sg-index'), 10);
              if (isNaN(idx)) return;
              dotsEl.querySelectorAll('.sg-dot').forEach(function(d, i) {
                d.classList.toggle('sg-dot--active', i === idx);
              });
            }
          });
        }, { root: track, threshold: [0.55, 0.9] });
        track.querySelectorAll('.sg-card').forEach(function(card) {
          observer.observe(card);
        });
      }

      rendered = true;
    }

    function escapeText(s) {
      if (s == null) return '';
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    function escapeAttr(s) {
      if (s == null) return '';
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  }

  /* ── Start ──
     Modal init runs independently of the case-switcher dropdown. On templates
     without a case-switcher (e.g., `luggage-b4u-v2`, where the trigger lives in
     the customizer-studio's controls column), repositionSwitcher() never
     succeeds — previously this kept initSizeGuideModal() from ever running.
     Decoupled here so the modal handler binds on every template that emits
     the modal markup. */
  function _bootstrap() {
    initSizeGuideModal();
    attemptReposition(20);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _bootstrap);
  } else {
    _bootstrap();
  }
})();
